export default class InProductMessageParser {
  message;

  placeholders = {};

  constructor(message) {
    this.message = message;

    const placeholders = message.match(/%[^%]*%/g);
    if (placeholders) {
      placeholders.forEach((placeholder) => {
        const [k, v] = placeholder.replace(/(^%)|(%$)/g, '').split('=');
        this.placeholders[k] = v;
      });
    }
  }

  parse() {
    return this.message.replace(/%([^%]*)%/g, '');
  }
}
